import { chartsMutationTypes } from '../mutation-types';

export function addPublicationsOverTimeWithDistributionPeriod({ commit }, period) {
  commit(chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_PERIOD, period);
}
